"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPageView = exports.trackEvent = exports.registerWithUserID = exports.register = exports.isbotNaive = void 0;
var Sentry = __importStar(require("@sentry/browser"));
var history_1 = require("history");
require("./googleTagManager");
var isQuotaExceededError_1 = require("./isQuotaExceededError");
var railsEnv_1 = require("./railsEnv");
var segment_1 = __importDefault(require("./segment"));
/**
 * User-agent used by Invicti, the web scanner we use at OpenDoor to scan for security concerns
 * We do not want to track events from Invicti in journey as they are not true UserEvents
 * ip: 54.88.149.100
 */
var naivePattern = /bot|spider|crawl|http|lighthouse|.*Netsparker|.*ThousandEyes-Dragonfly-x1|X-Athena/i;
var isbotNaive = function (userAgent) {
    return Boolean(userAgent) && naivePattern.test(userAgent);
};
exports.isbotNaive = isbotNaive;
var LOG_LEVEL_CONFIG_NAME = 'opendoor_log_level';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var log = function () {
    var _args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        _args[_i] = arguments[_i];
    }
    if (typeof window !== 'undefined' &&
        window.localStorage.getItem(LOG_LEVEL_CONFIG_NAME) === 'true') {
        // eslint-disable-next-line no-console
        console.log.apply(console, _args);
    }
};
var wrapQuotaError = function (cb) {
    try {
        cb();
    }
    catch (e) {
        if (!(0, isQuotaExceededError_1.isQuotaExceededError)(e)) {
            Sentry.captureException(e);
        }
    }
};
var register = function (traits) {
    if (typeof ga === 'function' && typeof traits === 'object') {
        ga('set', traits);
    }
    segment_1.default.identify(traits);
    if ((0, railsEnv_1.getRailsEnv)() !== 'production') {
        log("[DEBUG] Analytics.register: \n".concat(JSON.stringify(traits, null, 2)));
    }
};
exports.register = register;
// use this for logged on users, so we don't need to use ajs anonymous id
var registerWithUserID = function (userId, traits) {
    if (typeof ga === 'function' && typeof traits === 'object') {
        ga('set', traits);
    }
    segment_1.default.identify(userId, traits);
    if ((0, railsEnv_1.getRailsEnv)() !== 'production') {
        log("[DEBUG] Analytics.register: \n".concat(userId, " ").concat(JSON.stringify(traits, null, 2)));
    }
};
exports.registerWithUserID = registerWithUserID;
var trackEvent = function (category, action, value, extra) {
    // Exit early if it's a bot. Don't waste our Segment MTU quota
    if ((0, exports.isbotNaive)(navigator.userAgent)) {
        return;
    }
    // Have to copy-paste the try/catch because doing try/catch functionally
    // with generators is complicated
    wrapQuotaError(function () {
        // https://developers.google.com/analytics/devguides/collection/analyticsjs/events
        if (typeof ga === 'function') {
            ga('send', 'event', category, action, value, extra);
        }
    });
    wrapQuotaError(function () {
        // https://segment.com/docs/spec/track/
        segment_1.default.track("".concat(category, "-").concat(action), __assign({ channel: 'web', domain: window.location.host, screen: {
                height: window.screen.height,
                width: window.screen.width,
            }, value: value }, extra));
    });
    wrapQuotaError(function () {
        // https://support.google.com/tagmanager/answer/6106961?hl=en
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: "".concat(category, ".").concat(action, ".").concat(value), extra: extra });
    });
    if ((0, railsEnv_1.getRailsEnv)() !== 'production') {
        log("[DEBUG] Analytics.trackEvent: \n".concat(category, "-").concat(action, " ").concat(JSON.stringify(__assign({ value: value }, extra), null, 2)));
    }
};
exports.trackEvent = trackEvent;
var matchInAppQueryParam = function (queryParams) {
    var fragments = queryParams && queryParams.match(/app\=(\d+)/);
    if (!fragments) {
        return false;
    }
    return !!fragments[1];
};
var trackPageView = function (extra) {
    var history = (0, history_1.createBrowserHistory)();
    var pathname = history.location.pathname;
    var search = history.location.search;
    (0, exports.trackEvent)('page', 'view', 'page', __assign({ app: matchInAppQueryParam(search), pathname: pathname, search: search }, extra));
};
exports.trackPageView = trackPageView;
//# sourceMappingURL=analytics.js.map